export default __webpack_public_path__ + "static/media/7t.f3fae42a.jpg";